import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse } from '@material-ui/core';
import ConsultationRequestCard from '../ConsultationRequestCard';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { EnergyConsultationDetails } from '../../../__generated__/pge-types';
import { useTranslation } from '../../../hooks/useTranslation';
import CancelConsultationModal from '../CancelConsultationRequestModal';
import RescheduleConsultationModal from '../RescheduleConsultationRequestModal';

type Props = {
  consultations: EnergyConsultationDetails[] | undefined;
};

const UpcomingConsultationRequests: React.FC<Props> = ({ consultations }) => {
  const [expanded, setExpanded] = useState(true);
  const { t } = useTranslation();
  const [cancelRequestOpen, setCancelRequestOpen] = useState(false);
  const [rescheduleRequestOpen, setRescheduleRequestOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState<
    EnergyConsultationDetails
  >();

  if (!consultations || consultations.length === 0) {
    return <></>;
  }

  return (
    <Box mt={4}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        mb={2}
      >
        <Typography variant="h5" gutterBottom>
          {t('UPCOMING_CONSULTATION_REQUESTS')}
        </Typography>

        <IconButton size="small" onClick={() => setExpanded(prev => !prev)}>
          <ExpandMoreIcon
            style={{
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: '0.2s',
            }}
          />
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        {consultations?.map(item => (
          <ConsultationRequestCard
            key={item.requestId}
            consultation={item}
            onReschedule={id => {
              setRescheduleRequestOpen(true);
              setSelectedRequest(item);
            }}
            onCancel={() => {
              setCancelRequestOpen(true);
              setSelectedRequest(item);
            }}
          />
        ))}
      </Collapse>

      {cancelRequestOpen && selectedRequest && (
        <CancelConsultationModal
          requestId={selectedRequest.requestId}
          open={cancelRequestOpen}
          onClose={() => setCancelRequestOpen(false)}
        />
      )}

      {rescheduleRequestOpen && selectedRequest && (
        <RescheduleConsultationModal
          open={rescheduleRequestOpen}
          request={selectedRequest}
          onClose={() => setRescheduleRequestOpen(false)}
        />
      )}
    </Box>
  );
};

export default UpcomingConsultationRequests;
